function EmptyProjectIc({
    FrontCard,
    isShowTitle=false,
    width = 'w-[331px]',
    height = 'h-[363px]',
    fixW,
    image,
    ic,
    isFromAll=false
   
}) {
    return (
        <div className={` rounded ${fixW} mr-5`}>
            <div className={`  relative ${width} ${height}  `}>
                <div className="absolute top-0 left-0   h-[100%] ">{<FrontCard isShowTitle={true} isFromAll={isFromAll}  ic={ic} image={image} />}</div>
              
            </div>
        </div>
    );
}

export default EmptyProjectIc;
